import Image from 'next/image'

import { useReopenRequest } from '@/api/models/requests/hooks/useReopenRequest'
import ArrowBack from '@/assets/img/ArrowBack.png'
import { AppButton } from '@/components/shared/button'

import { ModalName } from './types/types'

type Props = {
  id: string
  onClose: () => void
  setModalName: (_: ModalName) => void
  refetchRequest: () => void
}

const ProblemNotSolvedForm = ({
  id,
  onClose,
  setModalName,
  refetchRequest
}: Props) => {
  const { mutateAsync: reopenRequest } = useReopenRequest(id)

  const handleGoBack = () => {
    onClose()
    setModalName(ModalName.AddRating)
  }

  const onSubmit = () => {
    reopenRequest()
      .then(() => {
        refetchRequest()
      })
      .finally(() => {
        onClose()
      })
  }

  return (
    <>
      <div className="sm:flex sm:h-full sm:flex-grow sm:flex-col sm:justify-center">
        <div className="flex justify-center gap-12">
          <Image src={ArrowBack.src} alt="img" width={140} height={140} />
        </div>

        <div className="mt-20 flex w-full justify-center">
          <p className="max-w-[370px] text-center text-grey-70 text-20">
            Спасибо! Ваше обращение возвращается на доработку, сотрудники Службы
            комфорта Sminex свяжутся с вами для уточнения деталей.
          </p>
        </div>
      </div>

      <div className="mt-20 flex flex-col gap-12">
        <AppButton
          variant="secondary"
          className="!h-56"
          fluid
          onClick={onSubmit}
        >
          Отправить на доработку
        </AppButton>
        <AppButton
          variant="backless"
          className="!h-56"
          fluid
          onClick={handleGoBack}
        >
          Не отправлять
        </AppButton>
      </div>
    </>
  )
}

export { ProblemNotSolvedForm }
